import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import { grey10 } from 'approot/shared/styles/colours.style';
import { spacing16, spacing8 } from 'approot/shared/styles/spacing.style';
import {
  roundButtonBase,
  RoundIconButton,
} from 'approot/shared/round-icon-button/round-icon-button.style';
import { SecondaryButton } from 'approot/shared/styles/buttons/buttons';

type DropdownKebabToggleProps = {
  $isSmallToggle?: boolean;
  $borderRadius?: number;
} & RoundIconButton;

export const DropdownKebabToggle = styled.button<DropdownKebabToggleProps>`
  ${roundButtonBase}

  ${({ $isSmallToggle }) =>
    $isSmallToggle &&
    `
    height: ${rem(32)};
    width: ${rem(32)};
  `}

  ${({ $borderRadius }) =>
    $borderRadius !== undefined &&
    `
    border-radius: ${rem($borderRadius)};
  `}
`;

export const DropdownSecondaryKebabToggle = styled(SecondaryButton)`
  display: flex;
  align-items: center;
`;

export const DropdownSecondaryKebabIcon = styled.div`
  svg {
    fill: ${grey10};
    stroke: ${grey10};
    margin-left: ${rem(spacing8)};

    ${mediaUp.sm`
    margin-left: ${rem(spacing16)};
  `};
  }
`;
